import React, { useEffect, useRef } from 'react';
import CampaignPreview from './CampaignPreview';
import './CampaignPreviewModal.css';

const CampaignPreviewModal = ({ open, onClose, ...previewProps }) => {
  const closeRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;

    const onKeyDown = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKeyDown);

    // Stop the page behind the dialog from scrolling under it
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    closeRef.current?.focus();

    return () => {
      document.removeEventListener('keydown', onKeyDown);
      document.body.style.overflow = previousOverflow;
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className="cpm-backdrop"
      onClick={onClose}
      role="presentation"
    >
      <div
        className="cpm-dialog"
        role="dialog"
        aria-modal="true"
        aria-label="Campaign preview"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="cpm-head">
          <h2 className="cpm-title">Storefront preview</h2>
          <button
            type="button"
            className="cpm-close"
            onClick={onClose}
            aria-label="Close preview"
            ref={closeRef}
          >
            ×
          </button>
        </div>

        <div className="cpm-body">
          <CampaignPreview {...previewProps} />
        </div>
      </div>
    </div>
  );
};

export default CampaignPreviewModal;
